
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("管理员列表", ["系统管理"]);
    });

    const store = useStore();
    const router = useRouter();
    const tableData = ref([]);

    const formData = ref({
      name: "",
      mobile: "",
    });

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    });

    const query = () => {
      store
        .dispatch(Actions.GET_ADMINS, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentAdmins;
          page.value.totalResult = store.getters.currentAdminCount;
        })
        .catch(() => {
          // const [error] = Object.keys(store.getters.getErrors);
          // Swal.fire({
          //   text: store.getters.getErrors[error],
          //   icon: "error",
          //   buttonsStyling: false,
          //   confirmButtonText: "Try again!",
          //   customClass: {
          //     confirmButton: "btn fw-bold btn-light-danger",
          //   },
          // });
        });
    };

    query();

    const submitEvent = () => {
      query();
    };

    const newAdmin = () => {
      router.push({ name: "admin_new" });
    };

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage;
      query();
    };

    const onReset = () => {
      formData.value = {
        name: "",
        mobile: "",
      };
    };

    const onDelete = (row) => {
      ElMessageBox.confirm(
        `确定要删除管理员「${row.name}」吗？`,
        "删除确认",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          store
            .dispatch(Actions.DELETE_ADMIN, row.id)
            .then((data: { success: boolean; error_msg?: string }) => {
              if (data.success) {
                ElMessage.success("删除成功");
                query();
              } else {
                ElMessage.error(data.error_msg || "删除失败");
              }
            })
            .catch(() => {
              ElMessage.error("删除失败");
            });
        })
        .catch(() => {
          // 用户取消
        });
    };

    return {
      tableData,
      formData,
      submitEvent,
      newAdmin,
      page,
      onPageChange,
      onReset,
      onDelete,
    };
  },
});
